var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTwoFaIcon = function SvgTwoFaIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 36.347C73 55.1485 58.9224 72.7334 40 76.9999C21.0776 72.7294 7 55.1485 7 36.347V21.5726C7 18.2065 9.02841 15.177 12.1276 13.9076L32.7511 5.43554C37.3978 3.52132 42.6062 3.52132 47.2449 5.43554L67.8684 13.9076C70.9716 15.1851 72.996 18.2065 72.996 21.5726L73 36.347V36.347Z",
    stroke: "#8E8E93",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6321 21C45.1737 21 49.6497 25.5064 49.6497 31.0176C49.6497 35.1587 47.1529 38.5994 42.7074 40.5481L46.3003 44.2019C46.7875 44.6891 46.7875 45.4199 46.3308 45.8462L42.5856 49.5913L45.2346 52.2404C45.6914 52.7276 45.7218 53.4279 45.2346 53.9151L40.4542 58.6651C39.9974 59.1218 39.358 59.0913 38.9317 58.6955L36.2827 56.1378C35.9173 55.8029 35.7346 55.3766 35.7042 54.8894V40.3045C31.9894 38.7516 29.584 35.1587 29.584 31.0176C29.584 25.5064 34.0295 21 39.6321 21ZM39.6016 25.9022C37.9574 25.9022 36.5872 27.2724 36.5872 28.9167C36.5872 30.5913 37.9574 31.9615 39.6016 31.9615C41.2458 31.9615 42.616 30.5913 42.616 28.9167C42.616 27.2724 41.2458 25.9022 39.6016 25.9022Z",
    fill: "#8E8E93"
  })));
};
export default SvgTwoFaIcon;